import { render } from "./FooterSection.vue?vue&type=template&id=ef92ad02"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=ef92ad02&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__